// jQuery is loaded by Sprockets outside the webpack bundle (webpack externals
// map 'jquery' -> window.jQuery), so the global can be absent: still loading,
// blocked, or failed on the client (Rollbar #3267). Resolve it lazily at call
// time — never capture it at module scope — and let callers degrade
// gracefully instead of throwing "$ is not a function".
let warnedMissing = false

export function jquery(): JQueryStatic | undefined {
  const jq = (window as unknown as { jQuery?: JQueryStatic; $?: JQueryStatic })
  const resolved = jq.jQuery || jq.$
  if (!resolved && !warnedMissing) {
    warnedMissing = true
    console.warn('[jquery] window.jQuery unavailable; jQuery-dependent UI enhancements disabled on this page.')
  }
  return resolved
}
